import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';

import Layout from '../../../components/Checkout/Layout';
import Breadcrumb from '../../../components/Checkout/Breadcrumb';
import Summary from '../../../components/Checkout/Summary';
import Shipping from '../../../components/Checkout/Shipping';

import { setTotalShippingCost } from '../../../redux/actions/shippingCostActions';
import apiShipping from '../../../api/Shipping';
import ApiShippingFL from '../../../api/Shipping/shippingApiFL';

import Config, { spanish } from '../../../config/config';

const ShippingPage = () => {
  const dispatch = useDispatch();
  const [content, setContent] = useState(false);
  const [shippingOption, setShippingOption] = useState(0);
  const cartId = useSelector((globalState) => globalState.cartInfo.IdCarrito);
  const totalShippingCost = useSelector(
    (globalState) => globalState.shippingCost.totalShippingCost
  );
  const totalShippingTax = useSelector(
    (globalState) => globalState.shippingCost.shippingTax
  );
  const [referralIdForm, setReferralIdForm] = useState(null);
  const referralId = useSelector(
    (globalState) => globalState.referralInfo.referralId
  );
  // const [shippingCost, setShippingCost] = useState(0);
  const history = useHistory();
  const [shippingOptions, setShippingOptions] = useState([]);
  const getShippingOptions = useCallback(async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdCarrito: cartId,
    };

    const resp = await ApiShippingFL.getShippingOptions(payload);
    if (resp.Codigo === 200) {
      setShippingOptions(resp.InfoFormasEnvio[0].FormasEnvio);
    }
  });

  const onChangeShippingOption = (e, cost, shippingTax) => {
    setShippingOption(parseInt(e.target.value, 10));
    dispatch(setTotalShippingCost(cost, shippingTax));
  };

  const onSubmitShippingForm = async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdCarrito: cartId,
      IdPaqueteria: shippingOption,
    };

    const resp = await ApiShippingFL.sendShippingOption(payload);
    if (resp.Codigo === 200) {
      const lang = spanish ? '/mex/es-mx' : '/mex/en-us';
      history.push(`${lang}/checkout/payment`);
    }
  };

  useEffect(async () => {
    setContent(await apiShipping.getContent());
    getShippingOptions();
  }, []);
  const title = spanish
    ? content?.MethodTitleSpanish
    : content?.MethodTitleEnglish;
  return (
    <Layout>
      <Helmet title={spanish ? 'Método de envío' : 'Delivery Methods'} />
      <Breadcrumb step={2} title={title} link="address" />
      <Shipping
        content={content}
        shippingOptions={shippingOptions}
        onChangeShippingOption={onChangeShippingOption}
        onSubmitShippingForm={onSubmitShippingForm}
        shippingOption={shippingOption}
      />
      <Summary
        edit
        shippingCost={totalShippingCost}
        shippingTax={totalShippingTax}
        setReferalId={setReferralIdForm}
        referralId={referralId}
        referralIdForm={referralIdForm}
      />
    </Layout>
  );
};

export default ShippingPage;
